import * as _ from 'lodash';
import { ApiService } from './api.service';
import { DOC_TEMPLATES } from './constant';
var TemplateService = (function () {
    function TemplateService(apiService) {
        this.apiService = apiService;
        this.documentTemplates = DOC_TEMPLATES;
    }
    TemplateService.prototype.get = function () {
        return this.documentTemplates;
    };
    TemplateService.prototype.getTemplate = function (type) {
        var template;
        _.forEach(this.documentTemplates, function (obj) {
            if (obj.type == type) {
                template = obj;
            }
        });
        return template;
    };
    TemplateService.prototype.getName = function (type) {
        var template = this.getTemplate(type);
        if (template == null)
            return null;
        else
            return template.name;
    };
    TemplateService.prototype.getNameEN = function (type) {
        var template = this.getTemplate(type);
        if (template == null)
            return null;
        else
            return template.nameEN;
    };
    TemplateService.prototype.getFullName = function (type) {
        var template = this.getTemplate(type);
        if (template == null)
            return null;
        return template.name + ' (' + template.nameEN + ')';
    };
    TemplateService.prototype.getDropdown = function (all) {
        if (all === void 0) { all = true; }
        var type = [];
        if (all) {
            type.push({
                label: 'ทั้งหมด',
                value: null
            });
        }
        _.forEach(this.documentTemplates, function (obj) {
            type.push({
                label: obj.name + ' (' + obj.nameEN + ')',
                value: obj.type
            });
        });
        // Hardcoded: Invoice
        type.push({
            label: 'ใบแจ้งหนี้ (Invoice)',
            value: 'other'
        });
        return type;
    };
    return TemplateService;
}());
export { TemplateService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/template.service.ts.pre-build-optimizer.js